<template>
  <div class="forumMainTable" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule" />
    <div class="content">
      <div class="day">
        <div class="left">
          <ForumDescription :image="daysInfo[0].image" :brief="daysInfo[0].brief" />
        </div>
        <div class="right" style="width: 178vh;margin-left: 5vh;">
          <img
            src="https://summit-img.geekpark.net/gpk-meeting-module/4-2-4-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-%E5%9B%BE%E7%89%87%E4%BB%8B%E7%BB%8D.jpg"
            style="height: 100vh; "
          />
        </div>
      </div>
      <div class="day">
        <div class="left">
          <ForumDescription :image="daysInfo[1].image" :brief="daysInfo[1].brief" />
        </div>
        <div class="right">
          <div class="schedule-table">
            <div
              class="row"
              v-for="(item,index) in scheduleFirst"
              v-if="item&&item.guests.length > 0"
              :key="index"
            >
              <span class="time">{{item.start_at | parseTime}}</span>
              <h5>{{item.title}}</h5>
              <span class="name">{{item.guests[0].name}}</span>
              <span class="company">{{item.guests[0].company}}</span>
              <span class="identity">{{item.guests[0].title}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="day">
        <div class="left">
          <ForumDescription :image="daysInfo[2].image" :brief="daysInfo[2].brief" />
        </div>
        <div class="right">
          <div class="schedule-table">
            <div
              class="row"
              v-for="(item,index) in scheduleSecond"
              v-if="item&&item.guests.length > 0"
              :key="100+index"
            >
              <span class="time">{{item.start_at | parseTime}}</span>
              <h5>{{item.title}}</h5>
              <span class="name">{{item.guests[0].name}}</span>
              <span class="company">{{item.guests[0].company}}</span>
              <span class="identity">{{item.guests[0].title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForumDescription from "./ForumDescription";
import ModuleNav from "./ModuleNav";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ForumMainTable",
  components: {
    ModuleNav,
    ForumDescription
  },
  data() {
    return {
      isInModule: false
    };
  },
  computed: {
    ...mapState({
      nav: state => state.forumMainTable.nav,
      daysInfo: state => state.forumMainTable.daysInfo
    }),
    scheduleFirst() {
      let tempSchedule =
        this.$store.state.global.vice_activities[0] &&
        this.$store.state.global.vice_activities[0].speeches[0].speeches;
      if (tempSchedule) {
        tempSchedule.slice().sort((prev, next) => {
          return (
            moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
          );
        });
        tempSchedule.length = 10;
      }
      return tempSchedule;
    },
    scheduleSecond() {
      let tempSchedule =
        this.$store.state.global.vice_activities[1] &&
        this.$store.state.global.vice_activities[1].speeches[0].speeches;
      if (tempSchedule) {
        tempSchedule.slice().sort((prev, next) => {
          return (
            moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
          );
        });
        tempSchedule.length = 10;
      }
      return tempSchedule;
    }
  },
  methods: {
    mouseEnter() {
      this.isInModule = true;
    },
    mouseLeave() {
      this.isInModule = false;
    }
  },
  filters: {
    parseTime: function(date) {
      if (moment(date).hours() < 12) {
        return moment(date).format("hh:mm") + " AM";
      } else {
        return moment(date).format("hh:mm") + " PM";
      }
    }
  }
};
</script>

<style scoped lang="less">
.forumMainTable {
  display: flex;
  height: 100vh;
  margin-left: 5vh;
}

.content {
  display: flex;
  margin-left: 5vh;

  > div {
    height: 100%;
    box-sizing: border-box;
  }
}

.day {
  padding: 5vh 0;
  display: flex;

  &:not(:last-of-type) {
    margin-right: 5vh;
  }

  .left {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: flex-start;
    width: 60vh;
    height: 90vh;
    position: relative;
  }

  .right {
    align-self: center;
    display: flex;

    .schedule-table {
      width: 100vh;
      margin-left: 6vh;

      .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2vh 0;
        border-bottom: 1px solid silver;
        font-weight: 500;

        > * {
          display: inline-block;
          font-size: 1.8vh;
        }

        .time {
          width: 17vh;
          text-align: left;
          font-weight: bold;
          font-family: SyncopateBold;
          color: #ff3c00;
        }

        h5 {
          width: 40vh;
        }

        .name {
          width: 10vh;
        }

        .company {
          width: 15vh;
          color: #ff3c00;
        }

        .identity {
          width: 16vh;
          padding-left: 3vh;
          color: #777;
        }
      }
    }
  }
}
</style>
